/**
 * 判断值是否为 HTML Element 或 Document
 * @return 是否为 HTML Element 或 Document
 */
export default function isElement(value) {
    return value instanceof Element || value instanceof Document;
}
//# sourceMappingURL=is-element.js.map